import "./LoginForm.css";
import { useState } from "react";

const LoginForm = ({ goToRegister, onLoginSuccess }) => {
  const [phone, setPhone] = useState("");
  const [isLoading, setIsLoading] = useState(false); // New loading state

  const handleProceed = async () => {
    if (phone.length !== 10) {
      alert("Please enter a valid 10-digit mobile number");
      return;
    }

    setIsLoading(true); // Start loading spinner

    try {
      const response = await fetch('/api/db', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          action: 'login', 
          data: { phone } 
        })
      });

      const result = await response.json();

      if (result.error || !result.data || result.data.length === 0) {
        alert("Client not found. Please register first.");
        setIsLoading(false); // Stop loading if error
        return;
      }

      onLoginSuccess(result.data);

    } catch (err) {
      console.error("Login Error:", err);
      alert("Network error. Please try again.");
      setIsLoading(false); // Stop loading if network fails
    }
  };

  return (
    <div className="login-container">
      <h2 className="login-title">
        Book an appointment with <br /> Dr. Shivani Vetkar
      </h2>

      {isLoading ? (
        <div className="loading-box">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <>
          <label className="login-label">Enter registered number</label>
          <input
            type="text"
            value={phone}
            onChange={(e) =>
              setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))
            }
            className="login-input"
            placeholder="10-digit mobile number"
            maxLength={10}
          />

          <button className="login-button" onClick={handleProceed}>
            Proceed
          </button>

          {/* This is now placed clearly below the Proceed button */}
          <button className="login-link" onClick={goToRegister}>
            Register new number
          </button>
        </>
      )}
    </div>
  );
};

export default LoginForm;
